import {ClientProps} from "@/interfaces/client_types.ts";

export function DefaultProps(): ClientProps {
    return {
        uuid: "",
        name: "",
        city: "",
        email: "",
        phone_number: "",
        state: "TX",
        postal_code: "",
        street_address: ""
    }
}